import { createContext } from "react";
import { ClientLocation } from "../../types/types";

export const SummaryPanelContext = createContext<
  ((loc: ClientLocation) => void) | null
>(null);
